import React, { useEffect, useState } from 'react';


const windowSize = Component => (
    React.forwardRef((props, ref) => {
        const [dimensions, setDimensions] = useState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        });

        useEffect(() => {
            function handleResize() {
                setDimensions({
                    windowHeight: window.innerHeight,
                    windowWidth: window.innerWidth
                });
            }
            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, []);
        return (
            <Component
                {...props}
                {...dimensions}
                ref={ref}
            />
        );
    }));

export default windowSize;
